export const JOBCAST_LOCATION_COL = "jobcastLocationCol";
export const COMMUNITY_FEE_COL = "communityFeeCol";
export const LAST_UPDATED_COL = "lastUpdatedCol";

export const COL_KEYS = [JOBCAST_LOCATION_COL, COMMUNITY_FEE_COL, LAST_UPDATED_COL];
